<section class="section-title">

  <div class="section-title-image">
    <img class="device-image" *ngIf='!device?.systemInfo.model || device?.systemInfo.model == "Bollard"'
      src="assets/img/device-pilomat.png" />
    <img class="device-image" *ngIf='device?.systemInfo.model == "Barrier"' src="assets/img/device-barrier.png" />
    <img class="device-image" *ngIf='device?.systemInfo.model == "Citygate"' src="assets/img/device-citygate.png" />
    <img class="device-image" *ngIf='device?.systemInfo.model == "Roadblocker"'
      src="assets/img/device-roadblocker.png" />
  </div>

  <div class="section-title-text">
    <h1 *ngIf='device?.systemInfo.reference'>{{ device?.systemInfo.reference }}</h1>
    <h1 *ngIf='!device?.systemInfo.reference || device?.systemInfo.name == ""'>Dispositivo senza nome</h1>


    <p>
      <ng-container i18n="@@device_detail_type">Tipo di dispositivo:</ng-container> {{device?.systemInfo.model}} <br />
      <ng-container i18n="@@device_detail_serial">Numero seriale:</ng-container> {{device?.serial}} <br />
      <ng-container *ngIf='device?.systemId'>
        <ng-container i18n="@@device_detail_system_id">Impianto:</ng-container> {{device?.systemId}}
      </ng-container>
      <ng-container *ngIf='( isAdmin() || isService() ) && device?.routerSerial'>
        <br />
        <ng-container i18n="@@device_detail_router_serial">Seriale router:</ng-container> {{device?.routerSerial}}
      </ng-container>
    </p>

    <app-loading-screen #deviceloader></app-loading-screen>

  </div>
</section>

<section>
  <div *ngIf="!isService()" fxLayout="row" fxLayoutAlign="end none">
    <a *ngIf="isAdmin()" (click)="editMap()" id="editMapButton" class="button activate-device">
      <ng-container i18n="@@devicedetail_activate_mapEdit">Sposta dissuasore
      </ng-container> <span>
        <fa-icon icon="truck"></fa-icon>
      </span>
    </a>
  </div>

  <br clear="all" />

  <agm-map *ngIf="device" [zoom]="mapZoom" [usePanning]="true" [latitude]="mapLat" [longitude]="mapLng"
    (mapReady)="mapReadyHandler($event)">

    <agm-marker [latitude]="device?.latitude" [longitude]="device?.longitude" [iconUrl]="device.icon"
      (markerClick)="onMarkerClicked(device)">

    </agm-marker>

  </agm-map>

  <div id="devicesLayout" fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutAlign="flex-start">

    <div fxFlex="65" [fxFlex.lt-md]="0">

      <div id="deviceIOCard" class="control-card-white margin-right-15 margin-top-15">

        <div class="control-card-header">
          <ng-container i18n="@@devicedetail_title">Dettagli dispositivo</ng-container>
          <!-- da capire se implementare
          "
          -->
          <fa-icon *ngIf="userCanDeviceEdit" icon="edit" class="float-right margin-right-20 icon-clickable"
            (click)="modifyDeviceDetails()">
          </fa-icon>
        </div>

        <div id="deviceDetailCard" class="control-card-content padding-15" fxLayout="row" fxLayoutAlign="start start">

          <div class="control-card-content" *ngIf="device" fxFlex="75">

            <div class="devicedetail-device-title">{{ device?.name }}</div>

            <ng-container *ngIf="device.systemInfo.productionDate" i18n="@@devicedetail_production_date">Data di
              produzione: </ng-container> {{ device?.systemInfo?.dateFriendly }}<br />
            <ng-container *ngIf="!device.systemInfo.productionDate" i18n="@@devicedetail_production_date">Data di
              produzione: </ng-container> {{ device?.systemInfo?.dateFriendlyEpoch }} <br />
            <ng-container i18n="@@devicedetail_installation_date">Data di
              installazione: </ng-container> {{ device?.dateFriendly }} <br /> <br />
            <ng-container i18n="@@devicedetail_order_confirmation">Order Confirmation: </ng-container> {{
            device?.orderConfirmation}}
            <br /><br />

            <ng-container i18n="@@devicedetail_version">Versione: </ng-container>{{ device?.systemInfo?.version }}
            <br />
            <ng-container i18n="@@devicedetail_software_version">Versione software dissuasore: </ng-container>{{
            device?.bollardSwVersion }}
            <br />
            <ng-container i18n="@@devicedetail_hardware_version">Versione hardware dissuasore: </ng-container>{{
            device?.bollardHwVersion }} <br />
            <br />
            <ng-container i18n="@@devicedetail_serial">Seriale dissuasore: </ng-container>{{ device?.bollardSerial }}
            <br />
            <ng-container i18n="@@devicedetail_firmwareversion">versione firmware: </ng-container>{{ device?.fwVersion
            }}
            <br />
            <ng-container i18n="@@devicedetail_model">Modello: </ng-container>{{ device?.systemInfo?.model }}
            <br /><br />
            <ng-container i18n="@@devicedetail_reference">Riferimento: </ng-container>{{ device?.systemInfo?.reference
            }}
            <br /><br />
            <div id="deviceDetailsIconsDiv">
              <ng-container i18n="@@devicedetail_canBusEnabled"> Can bus:
              </ng-container>
              <fa-icon class="deviceDetailIcon" *ngIf="!device.canBusEnabled" icon="circle" style="color: red;">
              </fa-icon>
              <fa-icon class="deviceDetailIcon" *ngIf="device.canBusEnabled" icon="circle" style="color: green;">
              </fa-icon>
              <br />
              <ng-container i18n="@@devicedetail_ioEthEnabled"> Scheda I/O :
              </ng-container>
              <fa-icon class="deviceDetailIcon" *ngIf="!device.ioEthEnabled" icon="circle" style="color: red;">
              </fa-icon>
              <fa-icon class="deviceDetailIcon" *ngIf="device.ioEthEnabled" icon="circle" style="color: green;">
              </fa-icon>
              <br />
              <ng-container i18n="@@device_details_licPlateEnabled"> Lettura targhe:
              </ng-container>
              <fa-icon class="deviceDetailIcon" *ngIf="!device.licensePlateEnabled" icon="circle" style="color: red;">
              </fa-icon>
              <fa-icon class="deviceDetailIcon" *ngIf="device.licensePlateEnabled" icon="circle" style="color: green;">
              </fa-icon>
              <br />
              <ng-container i18n="@@devicedetail_badge1Enabled"> Apertura con Tessera 1 :
              </ng-container>
              <fa-icon class="deviceDetailIcon" *ngIf="!device.badge1Enabled" icon="circle" style="color: red;">
              </fa-icon>
              <fa-icon class="deviceDetailIcon" *ngIf="device.badge1Enabled" icon="circle" style="color: green;">
              </fa-icon>
              <br />
              <ng-container i18n="@@devicedetail_badge2Enabled"> Apertura con Tessera 2 :
              </ng-container>
              <fa-icon class="deviceDetailIcon" *ngIf="!device.badge2Enabled" icon="circle" style="color: red;">
              </fa-icon>
              <fa-icon class="deviceDetailIcon" *ngIf="device.badge2Enabled" icon="circle" style="color: green;">
              </fa-icon>
              <br />
              <ng-container i18n="@@devicedetail_pin1Enabled"> Apertura con PIN 1 :
              </ng-container>
              <fa-icon class="deviceDetailIcon" *ngIf="!device.pin1Enabled" icon="circle" style="color: red;">
              </fa-icon>
              <fa-icon class="deviceDetailIcon" *ngIf="device.pin1Enabled" icon="circle" style="color: green;">
              </fa-icon>
              <br />
              <ng-container i18n="@@devicedetail_pin2Enabled"> Apertura con PIN 2 :
              </ng-container>
              <fa-icon class="deviceDetailIcon" *ngIf="!device.pin2Enabled" icon="circle" style="color: red;">
              </fa-icon>
              <fa-icon class="deviceDetailIcon" *ngIf="device.pin2Enabled" icon="circle" style="color: green;">
              </fa-icon>
              <br />
              <ng-container i18n="@@devicedetail_phoneEnabled"> Apertura con chiamata :
              </ng-container>
              <fa-icon class="deviceDetailIcon" *ngIf="!device.phoneEnabled" icon="circle" style="color: red;">
              </fa-icon>
              <fa-icon class="deviceDetailIcon" *ngIf="device.phoneEnabled" icon="circle" style="color: green;">
              </fa-icon>
              <br />
              <ng-container i18n="@@devicedetail_remoteEnabled"> Apertura con radiocomando :
              </ng-container>
              <fa-icon class="deviceDetailIcon" *ngIf="!device.remoteEnabled" icon="circle" style="color: red;">
              </fa-icon>
              <fa-icon class="deviceDetailIcon" *ngIf="device.remoteEnabled" icon="circle" style="color: green;">
              </fa-icon>
              <br />
              <ng-container i18n="@@devicedetail_appEnabled"> Apertura con app :
              </ng-container>
              <fa-icon class="deviceDetailIcon" *ngIf="!device.appEnabled" icon="circle" style="color: red;">
              </fa-icon>
              <fa-icon class="deviceDetailIcon" *ngIf="device.appEnabled" icon="circle" style="color: green;">
              </fa-icon>
              <!-- <br />
              <br />
              <ng-container i18n="@@devicedetail_watchDogEnabled"> WatchDog :
              </ng-container>
              <fa-icon class="deviceDetailIcon" *ngIf="!device.watchDogEnabled" icon="circle" style="color: red;">
              </fa-icon>
              <fa-icon class="deviceDetailIcon" *ngIf="device.watchDogEnabled" icon="circle" style="color: green;">
              </fa-icon> -->
            </div>
            <br /><br />
            <ng-container *ngIf="device.phoneNumber"><ng-container i18n="@@devicedetail_phone_number">Numero di
                telefono: +</ng-container>{{device?.phoneNumber}}</ng-container>
            <ng-container i18n="@@devicedetail_phone_number_not_set" *ngIf="!device.phoneNumber">Numero di telefono: Non
              impostato</ng-container>

            <br />
            <br /><br />
            <ng-container i18n="@@devicedetail_state">Stato: </ng-container>{{ device?.systemInfo?.country }} <br />
            <ng-container i18n="@@devicedetail_city">Città: </ng-container>{{ device?.systemInfo?.city }} <br />
            <ng-container i18n="@@devicedetail_address">Indirizzo: </ng-container>{{ device?.systemInfo?.address }}
            <br /><br />
          </div>

          <!-- <div id="admin-details" class="control-card-content" *ngIf="this.isAdmin()" fxFlex="50">
          <ng-container>
            testtesttest
            testtesttesttesttesttest
            testtesttest
            testtesttest
            testtesttesttesttesttest
            testtesttest
            testtesttest
            testtesttest
          </ng-container>

          <br>

          <img class="device-image" src="assets/img/device-pilomat.png" />

          <br>

          <img class="device-image" src="assets/img/device-pilomat.png" />

        </div> -->

        </div>
      </div>

      <app-device-ios *ngIf="device" [device]="device" [userCanDeviceEdit]="userCanDeviceEdit"> </app-device-ios>
      <!-- <app-device-log *ngIf="device" [device]="device" id="deviceLogDiv"></app-device-log> -->

    </div>

    <div fxFlex="35" [fxFlex.lt-md]="0">

      <div *ngIf="device" id="deviceDetailStateCard" class="control-card-white">

        <div class="control-card-header">
          <ng-container i18n="@@devicedetail_device_state">Stato dispositivo</ng-container>
        </div>

        <div class="control-card-content">

          <div class="devicedetail-position">
            <ng-container i18n="@@devicedetail_position"> Stato: </ng-container> {{ device.stateString }}
            <img id="stateIcon" src={{device.icon}} />
          </div>

          <div *ngIf="isAdmin() || isService()" class="devicedetail-vpnState">
            <ng-container *ngIf="device.vpnState == 1">
              <br>
              <ng-container i18n="@@devicedetail_vpn_state_conneted2">Stato VPN : Connessa</ng-container> <fa-icon
                class="vpnStateIcon" icon="circle" style="color: green;"></fa-icon>
            </ng-container>
            <ng-container *ngIf="device.vpnState == 0">
              <br>
              <ng-container i18n="@@devicedetail_vpn_state_not_conneted2">Stato VPN : Disconnessa</ng-container><fa-icon class="vpnStateIcon" icon="circle" style="color: red;"></fa-icon>
            </ng-container>
          </div>

          <br>
          <div class="devicedetail-lastupdate">
            <ng-container i18n="@@devicedetail_last_state_update" *ngIf="device.errors == '' && !dateError">Ultimo
              aggiornamento stato dispositivo:
            </ng-container>

            <!-- Se errore data non mostrare nulla -->
            <ng-container i18n="@@devicedetail_lastUpdate" *ngIf="device.errors == '' && dateError"></ng-container>

            <ng-container *ngIf="device.errors == ''">{{lastUpdateStr}}</ng-container>
          </div>

          <div class="devicedetail-synchronizing">
            <ng-container *ngIf="device.synchronizing && device.state != 'Offline'"><fa-icon style="color:#0072cf;"
                icon="refresh" style="margin-right: 10px;" [spin]="true" size="l"></fa-icon> <ng-container
                i18n="@@devicedetail_synchronizing">Sincronizzazione dati in corso...</ng-container> </ng-container>
            <ng-container *ngIf="device.synchronizing && device.state == 'Offline'"><fa-icon style="color:#0072cf;"
                icon="pause" style="margin-right: 10px;" size="l"></fa-icon> <ng-container
                i18n="@@devicedetail_synchronizing_paused">Sincronizzazione dati in
                attesa...</ng-container></ng-container>
            <ng-container *ngIf="!device.synchronizing && device.state != 'Offline'"><fa-icon style="color:#0072cf;"
                icon="check" style="margin-right: 10px;" size="l"></fa-icon><ng-container
                i18n="@@devicedetail_synchronizing_completed">Dati dispositivo aggiornati</ng-container>
            </ng-container>
          </div>
          <div class="devicedetail-error">
            <ng-container i18n="@@devicedetail_error" *ngIf="device.errors != ''">Errori: </ng-container>
            <ng-container *ngIf="device.errors != ''">{{ device.errors }}</ng-container>
          </div>

          <br>

          <!-- rimosso controllo service && !isService() -->
          <p *ngIf="(device?.canBusEnabled || device?.ioEthEnabled) && userCanDeviceAction"
            i18n="@@devicedetail_activate_the_device">Aziona il
            dispositivo:</p>


          <!-- <a *ngIf="device?.canBusEnabled" (click)="sendCloseCommand()" class="button activate-device" id="openButton">
            <ng-container i18n="@@devicedetail_lower_device">Alza</ng-container> <span>
              <fa-icon icon="arrow-up"></fa-icon>
            </span>
          </a>


          <a *ngIf="device?.canBusEnabled" (click)="sendOpenCommand()" class="button activate-device">
            <ng-container i18n="@@devicedetail_rise_device">Abbassa</ng-container> <span>
              <fa-icon icon="arrow-down"></fa-icon>
            </span>
          </a> -->

          <!-- Ex Passo-Passo + *ngIf="device?.canBusEnabled"  rimosso -->
          <!-- rimosso controllo service *ngIf="!isService()" -->

          <a *ngIf="userCanDeviceAction" (click)="sendOpenCommand()" class="button activate-device">
            <ng-container i18n="@@devicedetail_activate_device">Aziona</ng-container> <span>
              <fa-icon icon="play-circle"></fa-icon>
            </span>
          </a>

          <!-- <a *ngIf="device?.ioEthEnabled && !device?.canBusEnabled" (click)="sendOpenCommand()"
            class="button activate-device" id="openButton">
            <ng-container i18n="@@devicedetail_activate_device">Aziona</ng-container> <span>
              <fa-icon icon="play-circle"></fa-icon>
            </span>
          </a> -->

          <!-- rimosso controllo service *ngIf="!isService()" -->

          <a *ngIf="!device.forcedLow && userCanDeviceAction" (click)="sendForcedLowCommand()"
            class="button activate-device">
            <ng-container *ngIf="isUpDownType()" i18n="@@devicedetail_enable_forcedLow_device">Attiva forzato
              basso</ng-container>
            <ng-container *ngIf="!isUpDownType()" i18n="@@devicedetail_enable_forcedOpen_device">Attiva forzato
              aperto</ng-container>
            <span *ngIf="isUpDownType()">
              <fa-icon icon="arrow-down"></fa-icon>
            </span>
            <span *ngIf="!isUpDownType()">
              <fa-icon icon="right-left"></fa-icon>
            </span>
          </a>

          <a *ngIf="device.forcedLow && userCanDeviceAction" (click)="sendForcedLowCommand()"
            class="button activate-device">
            <ng-container *ngIf="isUpDownType()" i18n="@@devicedetail_disable_forcedLow_device">Disattiva forzato
              basso</ng-container>
            <ng-container *ngIf="!isUpDownType()" i18n="@@devicedetail_disable_forcedOpen_device">Disattiva forzato
              aperto</ng-container>
            <span>
              <fa-icon icon="undo"></fa-icon>
            </span>
          </a>

          <a *ngIf="isAdmin()" (click)="sendOTACommand()" class="button activate-device">
            <ng-container i18n="@@devicedetail_device_ota">OTA</ng-container> <span>
              <fa-icon icon="play-circle"></fa-icon>
            </span>
          </a>

          <a *ngIf="isAdmin() && owner" (click)="getDeviceUsers()" class="button activate-device">
            <ng-container i18n="@@devicedetail_device_resave_users">Gestisci utenti</ng-container> <span>
              <fa-icon icon="play-circle"></fa-icon>
            </span>
          </a>

          <a *ngIf="userCanDeviceReboot" (click)="sendRebootCommand()" class="button activate-device button-red">
            <ng-container i18n="@@devicedetail_device_reboot">Reboot</ng-container> <span>
              <fa-icon icon="play-circle"></fa-icon>
            </span>
          </a>

          <a *ngIf="isAdmin()" (click)="migration()" class="button activate-device button-red">
            <ng-container i18n="@@devicedetail_device_migration">Migrazione</ng-container> <span>
              <fa-icon icon="play-circle"></fa-icon>
            </span>
          </a>

        </div>

      </div>
      <br>
      <div id="deviceDetailOwnerCard" id="ownerDataCard" class="control-card-white">

        <div class="control-card-header">
          <ng-container i18n="@@devicedetail_owner">Gestore</ng-container>
          <fa-icon *ngIf="isAdmin() && owner" icon="search" class="float-right margin-right-20 icon-clickable"
            (click)="showOwner()">
          </fa-icon>
        </div>

        <div class="control-card-content" *ngIf="owner">

          {{ owner?.displayName }}<br />
          {{ owner?.email }}<br />
          <div *ngIf="isAdmin()">
            <br />
            <br />
            <ng-container i18n="@@devicedetail_press_to_unlink">Per scollegare il dispositivo dal gestore premere questo
              pulsante</ng-container>
            <br />
            <br />
            <a (click)="unlinkOwner()" class="button button-red">
              <ng-container i18n="@@devicedetail_unlink">Scollega
              </ng-container> <span>
                <fa-icon icon="unlink"></fa-icon>
              </span>
            </a>
            <br />
            <br />
            <br />
            <br />
          </div>
        </div>

        <div class="control-card-content" *ngIf="!owner">

          <ng-container i18n="@@devicedetail_noowner">Nessun gestore</ng-container>

          <div *ngIf="!isService()" class="buttons-container">
            <a (click)="setOwner()" class="button">
              <ng-container i18n="@@devicedetail_set_owner">Imposta gestore</ng-container> <span>
                <fa-icon icon="user"></fa-icon>
              </span>
            </a>
          </div>

        </div>


      </div>

      <div id="deviceStateDataDiv">

        <div id="deviceDetailCard" class="control-card-white">

          <div class="control-card-header">
            <ng-container i18n="@@devicedetail_device_data">Dati dispositivo</ng-container>
          </div>

          <div class="control-card-content" id="deviceStateDataDiv" *ngIf="device">

            <ng-container i18n="@@devicedetail_cycles_up">Numero cicli risalita:
            </ng-container> {{upCycleCounter?.value}} <br /><br />

            <ng-container i18n="@@devicedetail_cycles_down">Numero di cicli di
              abbassamento: </ng-container> {{downCycleCounter?.value}} <br /><br />

            <ng-container i18n="@@devicedetail_cycles_efo">Numero di cicli EFO:
            </ng-container> {{efoCycleCounter?.value}} <br /><br />

            <ng-container i18n="@@devicedetail_pressure_invertions">Numero di
              inversioni da pressione:
            </ng-container>{{pressureInvertionCounter?.value}} <br /><br />

            <ng-container i18n="@@devicedetail_safety_invertions">Numero di
              inversioni da Safety: </ng-container> {{SafetyInvertionCounter?.value}} <br /><br />

            <ng-container i18n="@@devicedetail_up_cycle_timeouts">Numero di timeout di
              risalita: </ng-container> {{raisingTimeoutCounter?.value}} <br /><br />

            <ng-container i18n="@@devicedetail_down_cycle_timeouts">Numero di timeout
              di abbassamento:
            </ng-container> {{loweringTimeoutCounter?.value}} <br /><br />

            <div id="dipSwitchesDiv" *ngIf="device.canBusEnabled">
              <ng-container i18n=" @@devicedetail_number_of_bollards">Numero di dissuasori:
              </ng-container> {{bollards?.value}} <br /><br />
              <div id="dipSwitchesStatesDiv">
                <ng-container i18n="@@devicedetail_dip_switch_state">Stato dip switch:</ng-container> <br> <br>
                <p *ngIf="dipSwitchesState[5] == false">AUTO:<fa-icon class="switchStateIcon"
                    *ngIf="dipSwitchesState[0] == false" icon="circle" style="color: red;"></fa-icon>
                  <fa-icon class="switchStateIcon" *ngIf="dipSwitchesState[0] == true" icon="circle"
                    style="color: green;"></fa-icon>
                </p>
                <p *ngIf="dipSwitchesState[5] == false">INP:<fa-icon class="switchStateIcon"
                    *ngIf="dipSwitchesState[1] == false" icon="circle" style="color: red;"></fa-icon>
                  <fa-icon class="switchStateIcon" *ngIf="dipSwitchesState[1] == true" icon="circle"
                    style="color: green;"></fa-icon>
                </p>
                <p *ngIf="dipSwitchesState[5] == false">LOOP: <fa-icon class="switchStateIcon"
                    *ngIf="dipSwitchesState[2] == false" icon="circle" style="color: red;"></fa-icon>
                  <fa-icon class="switchStateIcon" class="switchStateIcon" *ngIf="dipSwitchesState[2] == true"
                    icon="circle" style="color: green;"></fa-icon>
                </p>
                <p *ngIf="dipSwitchesState[5] == false">PR1: <fa-icon class="switchStateIcon"
                    *ngIf="dipSwitchesState[3] == false" icon="circle" style="color: red;"></fa-icon>
                  <fa-icon class="switchStateIcon" *ngIf="dipSwitchesState[3] == true" icon="circle"
                    style="color: green;"></fa-icon>
                </p>
                <p *ngIf="dipSwitchesState[5] == false">PR2:<fa-icon class="switchStateIcon"
                    *ngIf="dipSwitchesState[4] == false" icon="circle" style="color: red;"></fa-icon>
                  <fa-icon class="switchStateIcon" *ngIf="dipSwitchesState[4] == true" icon="circle"
                    style="color: green;"></fa-icon>
                </p>
                <p>SERVICE: <fa-icon class="switchStateIcon" *ngIf="dipSwitchesState[5] == false" icon="circle"
                    style="color: red;"></fa-icon>
                  <fa-icon class="switchStateIcon" *ngIf="dipSwitchesState[5] == true" icon="circle"
                    style="color: green;"></fa-icon>
                </p>
              </div>
            </div>
            <div class="devicedetail-lastupdate">
              <ng-container i18n="@@devicedetail_lastUpdate">Ultimo aggiornamento:
              </ng-container> {{ lastUpdateStr }}
            </div>
          </div>
        </div>
      </div>

    </div>
    <!-- da capire se implementare
          *ngIf=""
          -->
    <app-device-log *ngIf="device && userCanDeviceViewLogs" [device]="device" id="deviceLogDiv"></app-device-log>
  </div>

  <app-loading-screen #devicedetailsloader></app-loading-screen>

</section>